let DataDict = {
  "samp_pack": [{
    "id": "90",
    "label": "有",
    "value": "0"
  }, {
    "id": "91",
    "label": "无",
    "value": "1"
  }],
  "audit_status": [{
    "id": "111",
    "label": "草稿",
    "value": "0"
  }, {
    "id": "104",
    "label": "待审核",
    "value": "1"
  }, {
    "id": "105",
    "label": "审核通过",
    "value": "2"
  }, {
    "id": "106",
    "label": "审核不通过",
    "value": "3"
  }],
  "sample_type": [{
    "id": "27",
    "label": "待补录",
    "value": "0"
  }, {
    "id": "28",
    "label": "已完成",
    "value": "1"
  }],
  "index_type": [{
    "id": "157",
    "label": "产品查指标均值",
    "value": "0"
  }, {
    "id": "158",
    "label": "品类查指标均值",
    "value": "1"
  }, {
    "id": "159",
    "label": "品种查指标均值",
    "value": "2"
  }],
  "resolution_type": [{
    "id": "94",
    "label": "High Resolution",
    "value": "0"
  }, {
    "id": "95",
    "label": "Low Resolution",
    "value": "1"
  }],
  "post_type": [{
    "id": "132",
    "label": "联系人",
    "value": "0"
  }, {
    "id": "133",
    "label": "主任",
    "value": "1"
  }, {
    "id": "134",
    "label": "常务副主任",
    "value": "2"
  }, {
    "id": "135",
    "label": "副主任",
    "value": "3"
  }, {
    "id": "136",
    "label": "负责人",
    "value": "4"
  }, {
    "id": "137",
    "label": "技术负责人",
    "value": "5"
  }, {
    "id": "138",
    "label": "办公室主任",
    "value": "6"
  }, {
    "id": "139",
    "label": "检测室主任",
    "value": "7"
  }, {
    "id": "140",
    "label": "质量负责人",
    "value": "8"
  }],
  "handle_status": [{
    "id": "1",
    "label": "已处理",
    "value": "0"
  }, {
    "id": "2",
    "label": "未处理",
    "value": "1"
  }],
  "state": [{
    "id": "32",
    "label": "启用",
    "value": "0"
  }, {
    "id": "33",
    "label": "停用",
    "value": "1"
  }],
  "geo_image_type": [{
    "id": "162",
    "label": "产品图片",
    "value": "0"
  }, {
    "id": "163",
    "label": "VR",
    "value": "1"
  }, {
    "id": "164",
    "label": "视频",
    "value": "2"
  }, {
    "id": "171",
    "label": "产品主图",
    "value": "3"
  }],
  "image_type": [{
    "id": "39",
    "label": "产品",
    "value": "0"
  }, {
    "id": "40",
    "label": "包装",
    "value": "1"
  }, {
    "id": "41",
    "label": "品种",
    "value": "2"
  }, {
    "id": "42",
    "label": "注册证书",
    "value": "3"
  }, {
    "id": "43",
    "label": "品牌",
    "value": "4"
  }, {
    "id": "44",
    "label": "产地环境",
    "value": "5"
  }, {
    "id": "45",
    "label": "认证证书",
    "value": "6"
  }, {
    "id": "46",
    "label": "生产现场",
    "value": "7"
  }, {
    "id": "47",
    "label": "生产过程",
    "value": "8"
  }, {
    "id": "48",
    "label": "加工过程",
    "value": "9"
  }],
  "org_cate": [{
    "id": "99",
    "label": "法人单位",
    "value": "0"
  }, {
    "id": "100",
    "label": "二级单位",
    "value": "1"
  }],
  "polarity": [{
    "id": "75",
    "label": "Positive",
    "value": "0"
  }, {
    "id": "76",
    "label": "Negative",
    "value": "1"
  }],
  "memb_type": [{
    "id": "84",
    "label": "后台管理员",
    "value": "0"
  }, {
    "id": "85",
    "label": "生产销售企业类型",
    "value": "1"
  }, {
    "id": "86",
    "label": "检测机构用户类型",
    "value": "2"
  }, {
    "id": "87",
    "label": "农业主管部门",
    "value": "3"
  }],
  "judge_result": [{
    "id": "149",
    "label": "合格",
    "value": "0"
  }, {
    "id": "150",
    "label": "不合格",
    "value": "1"
  }],
  "stand_status": [{
    "id": "141",
    "label": "启用",
    "value": "0"
  }, {
    "id": "142",
    "label": "停用",
    "value": "1"
  }],
  "adver_space_type": [{
    "id": "172",
    "label": "PC幻灯",
    "value": "0"
  }, {
    "id": "173",
    "label": "PC图片",
    "value": "1"
  }, {
    "id": "174",
    "label": "WAP幻灯",
    "value": "2"
  }, {
    "id": "175",
    "label": "WAP图片",
    "value": "3"
  }],
  "meas_unit_type": [{
    "id": "9",
    "label": "公斤",
    "value": "0"
  }, {
    "id": "10",
    "label": "头",
    "value": "1"
  }, {
    "id": "11",
    "label": "尾",
    "value": "2"
  }, {
    "id": "12",
    "label": "羽",
    "value": "3"
  }, {
    "id": "13",
    "label": "个",
    "value": "4"
  }, {
    "id": "14",
    "label": "只",
    "value": "5"
  }, {
    "id": "15",
    "label": "枚",
    "value": "6"
  }, {
    "id": "16",
    "label": "棵",
    "value": "7"
  }, {
    "id": "17",
    "label": "毫升",
    "value": "8"
  }],
  "memb_status": [{
    "id": "88",
    "label": "正常",
    "value": "1"
  }, {
    "id": "89",
    "label": "冻结",
    "value": "0"
  }],
  "chiral_compound": [{
    "id": "64",
    "label": "ChiralCompound",
    "value": "1"
  }, {
    "id": "63",
    "label": "ChiralCompound",
    "value": "0"
  }],
  "is_judge": [{
    "id": "147",
    "label": "未判定",
    "value": "0"
  }, {
    "id": "148",
    "label": "已判定",
    "value": "1"
  }, {
    "id": "151",
    "label": "部分判定",
    "value": "2"
  }],
  "harm_type": [{
    "id": "101",
    "label": "病害",
    "value": "0"
  }, {
    "id": "102",
    "label": "虫害",
    "value": "1"
  }, {
    "id": "103",
    "label": "草害",
    "value": "2"
  }, {
    "id": "165",
    "label": "其他",
    "value": "3"
  }],
  "org_level": [{
    "id": "118",
    "label": "部级",
    "value": "0"
  }, {
    "id": "119",
    "label": "省级",
    "value": "1"
  }, {
    "id": "120",
    "label": "市级",
    "value": "2"
  }, {
    "id": "121",
    "label": "县级",
    "value": "3"
  }, {
    "id": "122",
    "label": "其他",
    "value": "4"
  }],
  "column_type": [{
    "id": "160",
    "label": "科普交流管理",
    "value": "0"
  }, {
    "id": "161",
    "label": "新闻动态管理",
    "value": "1"
  }],
  "org_cert_type": [{
    "id": "123",
    "label": "CMA",
    "value": "0"
  }, {
    "id": "124",
    "label": "CATL",
    "value": "1"
  }, {
    "id": "125",
    "label": "CNAS",
    "value": "2"
  }, {
    "id": "126",
    "label": "其他",
    "value": "3"
  }],
  "lod": [{
    "id": "154",
    "label": "0",
    "value": "0"
  }, {
    "id": "155",
    "label": "LOD",
    "value": "1"
  }, {
    "id": "156",
    "label": "1/2LOD",
    "value": "2"
  }],
  "status_flag": [{
    "id": "34",
    "label": "未审核",
    "value": "0"
  }, {
    "id": "35",
    "label": "已审核",
    "value": "1"
  }],
  "prdut_unit_type": [{
    "id": "22",
    "label": "生产",
    "value": "0"
  }, {
    "id": "23",
    "label": "进货",
    "value": "1"
  }],
  "login_flag": [{
    "id": "69",
    "label": "否",
    "value": "0"
  }, {
    "id": "70",
    "label": "是",
    "value": "1"
  }],
  "material_type": [{
    "id": "3",
    "label": "项目方案",
    "value": "0"
  }, {
    "id": "4",
    "label": "项目任务书",
    "value": "1"
  }, {
    "id": "5",
    "label": "项目中期报告",
    "value": "2"
  }, {
    "id": "6",
    "label": "项目原始数据",
    "value": "3"
  }, {
    "id": "7",
    "label": "项目年终报告",
    "value": "4"
  }, {
    "id": "8",
    "label": "项目验收报告",
    "value": "5"
  }],
  "adver_space_name": [{
    "id": "178",
    "label": "首页轮播广告",
    "value": "1"
  }, {
    "id": "179",
    "label": "产品查询广告",
    "value": "2"
  }, {
    "id": "180",
    "label": "特征指标广告",
    "value": "3"
  }, {
    "id": "181",
    "label": "科普交流广告",
    "value": "4"
  }, {
    "id": "182",
    "label": "风险管控广告",
    "value": "5"
  }, {
    "id": "183",
    "label": "新闻动态广告",
    "value": "6"
  }, {
    "id": "184",
    "label": "产业服务广告",
    "value": "7"
  }, {
    "id": "185",
    "label": "关于我们广告",
    "value": "8"
  }],
  "stand_cate": [{
    "id": "143",
    "label": "国家标准",
    "value": "0"
  }, {
    "id": "144",
    "label": "地方标准",
    "value": "1"
  }, {
    "id": "145",
    "label": "农业农村公告",
    "value": "2"
  }, {
    "id": "146",
    "label": "其他",
    "value": "3"
  }],
  "judge_std": [{
    "id": "152",
    "label": "未设定",
    "value": "0"
  }, {
    "id": "153",
    "label": "已设定",
    "value": "1"
  }],
  "samp_flag": [{
    "id": "92",
    "label": "有",
    "value": "0"
  }, {
    "id": "93",
    "label": "无",
    "value": "1"
  }],
  "prdut_rz_type": [{
    "id": "18",
    "label": "绿色食品",
    "value": "0"
  }, {
    "id": "19",
    "label": "有机农产品",
    "value": "1"
  }, {
    "id": "20",
    "label": "合格证",
    "value": "2"
  }, {
    "id": "21",
    "label": "其他",
    "value": "3"
  }, {
    "id": "169",
    "label": "地理标志产品",
    "value": "4"
  }],
  "resolution_ratio": [{
    "id": "77",
    "label": "低分辨率",
    "value": "0"
  }, {
    "id": "78",
    "label": "高分辨率",
    "value": "1"
  }],
  "p_status": [{
    "id": "49",
    "label": "草稿",
    "value": "0"
  }, {
    "id": "50",
    "label": "待审核",
    "value": "1"
  }, {
    "id": "51",
    "label": "审核通过",
    "value": "2"
  }, {
    "id": "52",
    "label": "审核不通过",
    "value": "3"
  }, {
    "id": "53",
    "label": "待审核（变更）",
    "value": "4"
  }, {
    "id": "54",
    "label": "草稿（变更）",
    "value": "5"
  }, {
    "id": "55",
    "label": "审核通过（变更未通过）",
    "value": "6"
  }],
  "task_status": [{
    "id": "96",
    "label": "未开始",
    "value": "0"
  }, {
    "id": "97",
    "label": "执行中",
    "value": "1"
  }, {
    "id": "98",
    "label": "已结束",
    "value": "2"
  }],
  "org_type": [{
    "id": "107",
    "label": "科研机构",
    "value": "0"
  }, {
    "id": "108",
    "label": "检测机构",
    "value": "1"
  }, {
    "id": "109",
    "label": "风险评估实验室",
    "value": "2"
  }, {
    "id": "110",
    "label": "风险评估实验站",
    "value": "3"
  }, {
    "id": "112",
    "label": "高校",
    "value": "4"
  }, {
    "id": "113",
    "label": "企业",
    "value": "5"
  }, {
    "id": "114",
    "label": "绿色食品定点检测机构",
    "value": "6"
  }, {
    "id": "115",
    "label": "农产品地理标志定点检测机构",
    "value": "7"
  }, {
    "id": "116",
    "label": "名特优新定点检测机构",
    "value": "8"
  }, {
    "id": "117",
    "label": "其他",
    "value": "9"
  }],
  "is_show": [{
    "id": "67",
    "label": "否",
    "value": "0"
  }, {
    "id": "68",
    "label": "是",
    "value": "1"
  }],
  "launch_start_type": [{
    "id": "186",
    "label": "上旬",
    "value": "0"
  }, {
    "id": "187",
    "label": "中旬",
    "value": "1"
  }, {
    "id": "188",
    "label": "下旬",
    "value": "2"
  }],
  "link_type": [{
    "id": "176",
    "label": "无操作",
    "value": "0"
  }, {
    "id": "177",
    "label": "链接地址",
    "value": "1"
  }],
  "permission_type": [{
    "id": "127",
    "label": "角色名称",
    "value": "0"
  }, {
    "id": "128",
    "label": "标普数据采集人员",
    "value": "1"
  }],
  "climate_type": [{
    "id": "56",
    "label": "热带季风气候",
    "value": "0"
  }, {
    "id": "57",
    "label": "亚热带季风气候",
    "value": "1"
  }, {
    "id": "58",
    "label": "温带季风气候",
    "value": "2"
  }, {
    "id": "59",
    "label": "高原山地气候",
    "value": "3"
  }, {
    "id": "60",
    "label": "温带大陆性气候",
    "value": "4"
  }, {
    "id": "61",
    "label": "热带雨林气候",
    "value": "5"
  }],
  "sms_template_type": [{
    "id": "62",
    "label": "smsCode",
    "value": "【化学海洋】验证码：{0}，{1}分钟内有效。若非本人操作，请忽略。"
  }],
  "test_result": [{
    "id": "36",
    "label": "未检测",
    "value": "0"
  }, {
    "id": "37",
    "label": "合格",
    "value": "1"
  }, {
    "id": "38",
    "label": "不合格",
    "value": "2"
  }],
  "expert_type": [{
    "id": "129",
    "label": "风险交流专家",
    "value": "0"
  }, {
    "id": "130",
    "label": "检验检测专家",
    "value": "1"
  }, {
    "id": "131",
    "label": "风险评估专家",
    "value": "2"
  }],
  "rz_type": [{
    "id": "166",
    "label": "地理标志产品",
    "value": "0"
  }, {
    "id": "167",
    "label": "名特优新农产品",
    "value": "4"
  }, {
    "id": "168",
    "label": "区域特色农产品",
    "value": "2"
  }],
  "samp_link_type": [{
    "id": "29",
    "label": "通用行业采样环节",
    "value": "0"
  }, {
    "id": "30",
    "label": "畜禽产品采样环节",
    "value": "1"
  }, {
    "id": "31",
    "label": "水产品采样环节",
    "value": "2"
  }],
  "project_level": [{
    "id": "24",
    "label": "部级项目",
    "value": "0"
  }, {
    "id": "25",
    "label": "省级项目",
    "value": "1"
  }, {
    "id": "26",
    "label": "市级项目",
    "value": "2"
  }],
  "ms_data_dict_type": [{
    "id": "71",
    "label": "化合物类别管理",
    "value": "4"
  }, {
    "id": "72",
    "label": "质谱类型管理",
    "value": "5"
  }, {
    "id": "73",
    "label": "仪器厂商管理",
    "value": "6"
  }, {
    "id": "74",
    "label": "结构类型管理",
    "value": "7"
  }],
  "org_user_type": [{
    "id": "82",
    "label": "法人单位",
    "value": "1"
  }, {
    "id": "83",
    "label": "技术机构",
    "value": "2"
  }],
  "geo_rz_type": [{
    "id": "101",
    "label": "中国农产品地理标志",
    "value": "0"
  }, {
    "id": "102",
    "label": "中国地理标志",
    "value": "1"
  }, {
    "id": "103",
    "label": "中欧互认互保地理标志",
    "value": "2"
  }],
  "abroad_rz_type":[{"id":"74753664110094456","label":"地理标识体系","value":"0"},{"id":"67475364110094456","label":"地理标志保护","value":"1"},{"id":"1094456747536416","label":"原产地保护","value":"2"}],
  "abroad_rz_type_en":[{"id":"74110094456475366","label":"（GI）","value":"0"},{"id":"67464110097534456","label":"（PGI）","value":"1"},{"id":"1456747536409416","label":"（PDO）","value":"2"}]
}

module.exports = DataDict



//////////////////
// WEBPACK FOOTER
// ./static/js/DataDictJs.js
// module id = KVXa
// module chunks = 45